import { render } from "./AppLabel.vue?vue&type=template&id=141ba9ea"
import script from "./AppLabel.vue?vue&type=script&lang=js"
export * from "./AppLabel.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jason\\Documents\\Saxton-Widgets\\saxton\\saxton-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__